import React from "react";
import { Link } from "react-router-dom";
import _ from "lodash";
import { Glyphicon } from "react-bootstrap";

import Table from "../../../../../components/common/table/Table";
import { formatDateSmall } from "../../../../../utils/dates";

import emailIcon from "../../../../../assets/images/email-icon.svg";
import messagesIcon from "../../../../../assets/images/speech-bubble-grey.svg";
import styles from "./AdminProjectPitches.scss";

const STATUS_ID_APPROVED = 8;

class AdminProjectPitches extends React.Component {
  constructor(props) {
    super(props);

    this.toogleRejectedProjects = this.toogleRejectedProjects.bind(this);

    this.state = {
      showRejectedProjects: false
    };

    this.contactApplicant = this.contactApplicant.bind(this);
  }

  getMemberLinkByStatus(member) {
    if (!member.status_id) return "#";
    if (member.status_id === STATUS_ID_APPROVED) {
      return `/admin/member/approved/${member.id}/profile`;
    }
    return `/admin/member/${member.id}/moderation`;
  }

  contactApplicant(email) {
    const link = `mailto:${email}`;
    const emailWindow = window.open(link, "emailWindow");

    setTimeout(() => {
      if (emailWindow && emailWindow.open && !emailWindow.closed) {
        emailWindow.close();
      }
    }, 10);
  }

  render() {
    const { project } = this.props;

    const pitchedMatches = this.getCurrentPitches(project.matches);

    const mappedRows = pitchedMatches.map(match => {
      return {
        rowKey: match.id,
        data: [
          {
            displayText: (
              <Link
                to={this.getMemberLinkByStatus(match.member)}
                className={styles.projectTitle}
              >
                {match.member.first_name + " " + match.member.last_name}
                <br />
                <div className={styles.locationText}>
                  {match.member.profile.city}
                </div>
              </Link>
            ),
            orderByText: match.member.first_name + match.member.last_name
          },
          {
            displayText: formatDateSmall(match.pitch.last_activity_at),
            orderByText: formatDateSmall(match.pitch.last_activity_at)
          },
          {
            displayText: this.getMessagesIcon(match.pitch, match.project_id),
            orderByText: match.pitch.total_messages
          },
          {
            displayText: (
              <div className={styles.actions}>
                <img
                  src={emailIcon}
                  alt="Letter"
                  className={styles.envelopeIcon}
                  onClick={() => this.contactApplicant(match.member.email)}
                />
              </div>
            )
          }
        ],
        disabled: match.pitch.accepted === false
      };
    });

    const tableData = {
      headers: [
        {
          displayText: "Member Name"
        },
        {
          displayText: "Last Activity"
        },
        {
          displayText: "Messages"
        },
        {
          displayText: " "
        }
      ],
      rows: mappedRows
    };

    return (
      <div className={styles.projectIndex}>
        <h2 className={styles.pageTitle}>
          Pitches
          <span>{this.getFilterButtons()}</span>
        </h2>

        <Table
          colsConfig={["40%", "25%", "20%", "15%"]}
          name="AdminProjectPitches"
          tableData={tableData}
        />
      </div>
    );
  }

  getCurrentPitches(projectMatches) {
    let matches;

    if (this.state.showRejectedProjects) {
      matches = _.filter(projectMatches, match => {
        return match.pitched === true;
      });
    } else {
      matches = _.filter(projectMatches, match => {
        return match.pitched === true && match.pitch.accepted !== false;
      });
    }

    return matches;
  }

  getFilterButtons() {
    const toogleRejectedComponent = this.state.showRejectedProjects ? (
      <span>
        {" "}
        <Glyphicon glyph="eye-close" /> &nbsp; Hide Rejected{" "}
      </span>
    ) : (
      <span>
        {" "}
        <Glyphicon glyph="eye-open" /> &nbsp; Show Rejected{" "}
      </span>
    );

    return (
      <div className={styles.filterButtons}>
        <span
          className={styles.filterButtonsItem}
          onClick={this.toogleRejectedProjects}
        >
          {toogleRejectedComponent}
        </span>
      </div>
    );
  }

  toogleRejectedProjects() {
    this.setState(prevState => {
      return {
        showRejectedProjects: !prevState.showRejectedProjects
      };
    });
  }

  getMessagesIcon(pitch, projectId) {
    let messagesCount = pitch.total_messages;

    if (messagesCount < 10) {
      messagesCount = "0" + messagesCount;
    }

    return (
      <div>
        <Link
          to={`/admin/project/${projectId}/pitch/${pitch.id}/messages`}
          className={styles.messages}
        >
          <img
            src={messagesIcon}
            alt="Messages"
            className={styles.messagesImage}
          />
          <span className={styles.messagesText}>{messagesCount}</span>
        </Link>
      </div>
    );
  }
}

export default AdminProjectPitches;



// WEBPACK FOOTER //
// ./src/routes/admin/project/pitches/components/AdminProjectPitches.js